module.exports = __webpack_public_path__ + "static/7-9cb2ab0fdc9fedb68812b52a3386972b.jpg";